<div role="alert">
    <div class="loading-spinner" *ngIf="loading">
        <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
        <div class="spinner">
            <div></div>
            <div></div>
        </div>
        <div class="loading-text">Loading..</div>
    </div>
</div>
<div class="bottom-20"></div>
<div class="content">
    <div class="container">
        <button #focusableEleTop class="focusable-element"></button>
        <!--<ValidatedTextField class="medicare-number"
                            [label]="'Medicare Number'"
                            [text]="TestData"
                            [disabled]="disabled" [maxlength]="20"
                            (onValueChange)="updateInfoMediacare('medicareId',$event)">
        </ValidatedTextField>-->
        <form (keydown)="onKeyDown($event)">
            <div *ngIf="showPage">
                <div class="row" *ngIf="!isValid">
                    <div class="col-24">
                        <div class="alert danger">
                            <p><em>Error Message:</em></p>
                            <ul>
                                <li *ngFor="let error of ErrorMessages" style="color:red">
                                    <button [innerHtml]="error"></button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <fieldset>
                    <legend>Please verify your details</legend>
                    <div class="row">
                        <div class="col-16">
                            <p>Hi {{userName}}.  Please enter the date below to verify your identity so you can view and sign your application</p>
                            <p><strong>Note:</strong> Three incorrect attempts will lock your application, and you will need to follow up with your agent.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="medicare-number"
                                                    [label]="'Medicare Number'"
                                                    [validators]="[]"
                                                    [text]="medicareNumber"
                                                    [disabled]="disabled" [maxlength]="20"
                                                    (onValueChange)="updateInfoMediacare('medicareId',$event)">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="last-name"
                                                    [label]="'Last Name'"
                                                    [validators]="[]"
                                                    [text]="lastName"
                                                    [disabled]="disabled"
                                                    (onValueChange)="lastName=$event">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <!--<label>Date of Birth (MM/DD/YYYY)</label>
                                <JQDatePicker [selectedDate]="DOB"
                                              (elementClicked)="updateInfo('dateOfBirth',$event)">
                                </JQDatePicker>-->
                                <ValidatedDateTextField [label]="'Date of Birth :'"
                                                        id="dateofBirth"
                                                        [date]="DOB"
                                                        (onDateChange)="DOB = $event"
                                                        [validators]="[dateTextFieldValidator,notBlankValidator]">
                                </ValidatedDateTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24">
                            <button id="verifyEAP" class="button primary" (click)="verify()">Verify</button>
                        </div>
                    </div>
                </fieldset>
            </div>
        </form>
        <div *ngIf="showText">
            <div class="row">
                <div class="col-16">
                    <div class="eapp-esoalinkexpired" *ngIf="!showExpiredMsg">
                        <p><strong>URL/Page has expired.</strong></p>
                    </div>
                    <div class="eapp-esoalinkexpired" *ngIf="showExpiredMsg">
                        <p><strong>You have attempted to validate your information three times unsuccessfully. Your application has been locked. Please ask your agent to re-send your electronic application.</strong></p>
                    </div>
                    <div>
                        <p>
                            You must continue to pay your Medicare Part B premium.
                            SilverScript Insurance Company complies with applicable Federal civil rights laws and does not discriminate on the basis of race, color, national origin, age, disability, or sex.
                            ATTENTION: If you speak English, language assistance services, free of charge, are available to you. Call 1-866-235-5660 (TTY: 711), 24 hours a day, 7 days a week. ATENCIÓN: Si usted habla español, tenemos servicios de asistencia lingüística disponibles para usted sin costo alguno. Llame al 1-866-235-5660 (TTY: 711), las 24 horas del día, los 7 días de la semana. 小贴士: 如果您说中文，欢迎使用免费语言协助服务。请拨1-866-235-5660 (TTY: 711)。一周7天，每天24小时随时受理。
                            SilverScript Employer PDP is a Prescription Drug Plan. This plan is offered by SilverScript Insurance Company, which has a Medicare contract. Enrollment depends on contract renewal.
                            ©2016 SilverScript Insurance Company. All Rights Reserved.
                            Y0080_12316_WEB_2016 Pending Last Updated: 09/09/2016
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>